import {
  Backdrop,
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  Modal,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../../../../scss/pages/Attendance/Component/Checklist/Planner/Planner.scss";
import noScheduleIcon from "../../../../../asset/svg/noScheduleIcon.svg";
import PlaceIcon from "@mui/icons-material/Place";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { useLocation, useNavigate } from "react-router";
import {
  ADMIN_PATH,
  CHECKLIST_EDIT_SCHEDULE_PATH,
  CHECKLIST_SELECT_STORE_PATH,
} from "../../../../../utils/Constants";
import LeftArrow from "../../../../../asset/svg/leftArrow.svg";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_CHECKLIST_STORE_DATA,
  GET_SCHEDULE_DATA,
} from "../../../../../sagas/type";
import moment from "moment";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
const getCurrentMonthYear = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = (today.getMonth() + 1).toString().padStart(2, "0"); // Ensure two digits
  return `${currentYear}-${currentMonth}`;
};

function Planner() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const { getScheduleData, getStores } = useSelector(mapStateToProps);
  const [selectedMonthYear, setSelectedMonthYear] = useState(
    getCurrentMonthYear()
  );
  const [value, setValue] = useState(1);
  const [storesData, setStoresData] = useState([]);
  const [filterOpen, setFilterOPen] = useState(false);
  const [statusData, setStatusData] = useState("UPCOMING");
  const [scheduleData, setScheduleData] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);

  useEffect(() => {
    if (getScheduleData && getScheduleData?.length) {
      setScheduleData(getScheduleData);
    }
  }, [statusData]);

  useEffect(() => {
    if (getStores && getStores?.length) {
      setStoresData(getStores);
    }
  }, [getStores]);

  // startDate & endDate
  const getStartAndEndDateOfMonth = (inputDate) => {
    const [year, month] = inputDate.split("-");
    const startDate = new Date(`${year}-${month}-01`);
    const lastDay = new Date(year, month, 0);
    const endDate = lastDay.toISOString().split("T")[0];
    return { startDate: startDate.toISOString().split("T")[0], endDate };
  };
  const { startDate, endDate } = getStartAndEndDateOfMonth(selectedMonthYear);
  const getStatusColor = (status) => {
    switch (status) {
      case "MISSED":
        return {
          border: "1px solid #FF7272",
          background: "rgba(255, 114, 114, 0.20)",
        };
      case "COMPLETED":
        return {
          border: "1px solid #6FDF97",
          background: "rgba(111, 223, 151, 0.20)",
        };
      case "DUE":
        return {
          border: "1px solid #EAA439",
          background: "rgba(234, 164, 57, 0.20)",
        };
      case "NONE":
        return {
          border: "1px solid #12B9DD",
          background: "rgba(18, 185, 221, 0.20)",
        };
      default:
        return {
          border: "1px solid #FFF",
          background: "rgba(255, 255, 255, 0.20)",
        };
    }
  };
  const focusedTab = {
    color: "black",
    padding: "1px",
    background: "#FFFFFF",
    borderRadius: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    fontSize: "10px",
    fontFamily: "'Noto Sans', sans-serif",
  };
  const unFocused = {
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1px",
    background: "rgba(255, 255, 255, 0.1)",
    fontWeight: 500,
    fontSize: "10px",
    borderRadius: "40px",
    fontFamily: "'Noto Sans', sans-serif",
  };

  const handleAddSchedule = () => {
    navigate(CHECKLIST_SELECT_STORE_PATH);
  };
  const handleEditSchedule = (item) => {
    navigate(CHECKLIST_EDIT_SCHEDULE_PATH, {
      state: {
        editData: item,
        filterState: { selectedMonthYear, statusData, selectedStores },
      },
    });
  };

  const handleChange = (event, newValue) => {
    const arrayData = ["ALL", "UPCOMING", "DUE", "MISSED", "COMPLETED"];
    const data = arrayData[newValue];
    setStatusData(data);
    setValue(newValue);
  };
  const handleMontheChange = (event) => {
    const monthD = event.target.value;
    setSelectedMonthYear(monthD);
  };

  const handleBack = () => {
    navigate(ADMIN_PATH);
  };

  const handleTypeChange = (event) => {
    const storeName = event.target.value;
    if (selectedStores.includes(storeName)) {
      setSelectedStores(selectedStores.filter((store) => store !== storeName));
    } else {
      setSelectedStores([...selectedStores, storeName]);
    }
  };

  const handleOpenFilter = () => {
    setFilterOPen(true);
    dispatch({
      type: GET_CHECKLIST_STORE_DATA,
      setLoader: setLoader,
    });
  };

  useEffect(() => {
    setLoader(true);
    dispatch({
      type: GET_SCHEDULE_DATA,
      payload: {
        statusData: statusData,
        startDate: startDate,
        endDate: endDate,
        selectedStores: selectedStores,
      },
      setScheduleData: setScheduleData,
      setLoader: setLoader,
      selectedStores: selectedStores,
    });
  }, [selectedMonthYear, statusData, selectedStores]);

  const handleFilterDone = () => {
    setFilterOPen(false);
  };

  useEffect(() => {
    if (location?.state && location?.state?.filterState) {
      const { selectedMonthYear, statusData, selectedStores } =
        location.state.filterState;
      setSelectedMonthYear(selectedMonthYear);
      setStatusData(statusData);
      setSelectedStores(selectedStores);
    } else {
      setSelectedMonthYear(selectedMonthYear);
    }
  }, [location?.state]);

  const groupedScheduleData = scheduleData?.reduce((grouped, item) => {
    const startDate = item?.startDate;

    if (grouped[startDate]) {
      grouped[startDate].push(item);
    } else {
      grouped[startDate] = [item];
    }

    return grouped;
  }, {});

  const renderedScheduleData = Object.keys(groupedScheduleData)?.map(
    (startDate) => (
      <div key={startDate}>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#FFF",
            fontWeight: 700,
            marginBottom: "0.2rem",
            paddingLeft: "2px",
          }}
        >
          {moment(startDate).format("DD MMM") ===
          moment(new Date()).format("DD MMM")
            ? moment(startDate).format("DD MMM") + " (Today)"
            : moment(startDate).format("DD MMM")}
        </Typography>
        {groupedScheduleData[startDate]?.map((item) => (
          <Box
            key={item.id}
            sx={{
              borderRadius: "12px",
              background: "rgba(255,255,255,0.05)",
              marginBottom: "10px",
            }}
          >
            <div
              className="border-design"
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "flex-start",
              }}
            >
              <div style={{ width: "100%", padding: "0.6rem" }}>
                <div className="Planner-container_Cards-container_card-Parent-Container">
                  <div className="Planner-container_Cards-container_card-Parent-Container_card-Heading">
                    <PlaceIcon
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        fontSize: "15px",
                        color: "rgba(141, 200, 255, 1)",
                      }}
                    />
                    <Typography
                      sx={{
                        color: "rgba(255, 255, 255, 0.40)",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "12px",
                        textTransform: "capitalize",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: "'Noto Sans', sans-serif",
                      }}
                      value="name"
                    >
                      {item?.storeCode} -
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(255, 255, 255, 0.40)",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "12px",
                        textTransform: "capitalize",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: "'Noto Sans', sans-serif",
                      }}
                      value="name"
                    >
                      {item?.storeName}
                    </Typography>
                  </div>
                  {item?.latestEventStatus !== "COMPLETED" && (
                    <div
                      className="Planner-container_Cards-container_Edit"
                      onClick={() => handleEditSchedule(item)}
                    >
                      <DriveFileRenameOutlineIcon
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          fontSize: "17px",
                          color: "rgba(255, 255, 255, 1)",
                        }}
                      />
                    </div>
                  )}
                </div>
                <div>
                  <Typography
                    sx={{
                      color: "#FFF",
                      fontWeight: 600,
                      fontSize: "14px",
                      lineHeight: "17px",
                      padding: "0px",
                      fontFamily: "'Noto Sans', sans-serif",
                    }}
                  >
                    {item?.checklistName}
                  </Typography>
                </div>
                <div className="Planner-container_Cards-container_Status-chip">
                  <Stack
                    direction="row"
                    sx={{
                      ...getStatusColor(item?.latestEventStatus),
                      height: "22px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "fit-content",
                      borderRadius: "4px",
                    }}
                  >
                    <Chip
                      label={
                        item?.latestEventStatus === "NONE"
                          ? "Upcoming"
                          : item?.latestEventStatus.charAt(0).toUpperCase() +
                            item?.latestEventStatus.slice(1).toLowerCase()
                      }
                      sx={{
                        fontSize: "24px",
                        fontWeight: 600,
                        color:
                          item?.latestEventStatus === "MISSED"
                            ? "#FF7272"
                            : item?.latestEventStatus === "COMPLETED"
                            ? "#6FDF97"
                            : item?.latestEventStatus === "DUE"
                            ? "#EAA439"
                            : item?.latestEventStatus === "NONE"
                            ? "#12B9DD"
                            : "#FFF",
                      }}
                    />
                  </Stack>
                </div>
              </div>
            </div>
          </Box>
        ))}
      </div>
    )
  );

  return (
    <div className="Planner-container">
      <div className="Planner-container_header">
        <div>
          {/* <img className='Planner-container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp; */}
          <span className="Planner-container_header_content">Planner</span>
        </div>
        <div>
          {getScheduleData && getScheduleData?.length > 0 && (
            <Typography
              sx={{
                color: "#8074FF",
                fontWeight: 700,
                fontSize: "14px",
                fontFamily: " 'Noto Sans', sans-serif",
                textAlign: "right",
                lineHeight: "20px",
              }}
              onClick={handleOpenFilter}
            >
              Filter
            </Typography>
          )}
        </div>
      </div>
      <div className="Planner-container_MonthPicker">
        <input
          type="month"
          id="monthPicker"
          value={selectedMonthYear}
          onChange={handleMontheChange}
          placeholder="Select Month"
          className="Planner-container_MonthPicker_calender"
        />
      </div>
      <div className="Planner-container_tabs-Container">
        <Tabs
          value={value}
          onChange={handleChange}
          sx={{ minWidth: "320px", overflowX: "auto", marginTop: "0.5rem" }}
        >
          <Tab
            label="All"
            {...a11yProps(0)}
            style={value == 0 ? focusedTab : unFocused}
          />
          <Tab
            label="Upcoming"
            {...a11yProps(1)}
            style={value == 1 ? focusedTab : unFocused}
          />
          <Tab
            label="Due"
            {...a11yProps(2)}
            style={value == 2 ? focusedTab : unFocused}
          />
          <Tab
            label="Missed"
            {...a11yProps(3)}
            style={value == 3 ? focusedTab : unFocused}
          />
          <Tab
            label="Completed"
            {...a11yProps(4)}
            style={value == 4 ? focusedTab : unFocused}
          />
        </Tabs>
      </div>
      {loader ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer - 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <>
          {scheduleData?.length > 0 ? (
            <div className="Planner-container_Cards-container">
              {renderedScheduleData}
            </div>
          ) : (
            <div className="Planner-container_No-records-found">
              {loader ? (
                <CircularProgress />
              ) : (
                <div className="Planner-container_No-records-found_child">
                  <div
                    className="Planner-container_No-records-found_child_Image"
                    alt="No Records Found"
                  >
                    <img src={noScheduleIcon} />
                  </div>
                  <div className="Planner-container_No-records-found_child_Text-content">
                    <Typography
                      className="Planner-container_No-records-found_child_Text-content_Text"
                      sx={{ fontFamily: "'Noto Sans', sans-serif" }}
                    >
                      No Schedule Yet
                    </Typography>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}

      <div className="Planner-container_Download-button">
        <div className="Planner-container_Download-button_btn-bottom">
          <div className="Planner-container_Download-button_btn-bottom_okbutton-container">
            <button
              id="downloadBtn"
              className="Planner-container_Download-button_btn-bottom_okbutton-container_active-button"
              onClick={handleAddSchedule}
            >
              Add Schedule
            </button>
          </div>
        </div>
      </div>
      <Modal
        open={filterOpen}
        onClose={() => setFilterOPen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <div className="Planner-container_filter-modal">
          <Box
            sx={{
              backgroundColor: "#0B245F",
              borderRadius: "1rem",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <HorizontalRuleIcon
              onClick={() => setFilterOPen(false)}
              sx={{
                top: 10,
                left: "50%",
                position: "absolute",
                width: "30px",
                height: "3px",
                opacity: 0.4,
                background: "#FFF",
              }}
            />
            <div className="Planner-container_filter-modal_content">
              <div className="Planner-container_filter-modal_content_header-text">
                <Typography
                  sx={{
                    color: "#FFF",
                    fontSize: "16px",
                    fontWeight: 700,
                    paddingLeft: "0.7rem",
                  }}
                >
                  Store
                </Typography>
              </div>
              <div className="Planner-container_filter-modal_content_filterItems">
                {storesData?.map((category, index) => {
                  return (
                    <div
                      key={index}
                      className="Planner-container_filter-modal_content_filterItems_data"
                    >
                      <label
                        htmlFor={`checkbox-${category?.storeCode}`}
                        className="Planner-container_filter-modal_content_filterItems_data_checkbox-label"
                      >
                        <Checkbox
                          id={`checkbox-${category?.storeCode}`}
                          onChange={handleTypeChange}
                          checked={selectedStores?.includes(
                            category?.storeName
                          )}
                          {...label}
                          value={category?.storeName}
                          color="primary"
                          sx={{
                            color: "#fff",
                            "&.Mui-checked": {
                              color: "#8074FF",
                              opacity: "1",
                            },
                            opacity: "0.3",
                          }}
                        />
                        <Typography
                          sx={{
                            color: "#FFF",
                            fontSize: "14px",
                            fontWeight: 600,
                          }}
                        >
                          {category?.storeName}
                        </Typography>
                      </label>
                    </div>
                  );
                })}
              </div>
              <div className="Planner-container_filter-modal_content_filter-Done-button">
                <button
                  type="submit"
                  disabled={""}
                  className="Planner-container_filter-modal_content_filter-Done-button_active-button"
                  onClick={() => handleFilterDone()}
                >
                  Apply
                </button>
              </div>
            </div>
          </Box>
        </div>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    getScheduleData: state?.checklist?.getScheduleData,
    getStores: state?.checklist?.getStores,
  };
};

export default Planner;
